import { Messages } from "../../core/api";
import { auth } from "../../core/auth";

/**
 * One permission per beta feature, in the "Beta Features" group.
 *
 * They gate whether the switch is offered, not what it switches — the pages behind
 * them keep their own permissions, so granting one of these to somebody who cannot
 * open the caregivers list gives them a switch that changes nothing.
 *
 * Kept here rather than in the modal because the sidebar asks the same question to
 * decide whether to offer the modal at all, and two lists would drift.
 */
export const BETA_FEATURE_PERMISSION = {
  caregiverMemoryImprovements: "use_caregiver_memory_improvements",
  patientMemoryImprovements: "use_patient_memory_improvements",
  betaProfileWindow: "use_beta_profile_window",
  aiSearch: "use_ai_search",
} satisfies Record<string, Messages["AgencyMemberPermission"]>;

/**
 * Whether this member has any beta feature at all.
 *
 * The modal is nothing but the switches, so with none of them available it would
 * open onto four rows of "your role does not have access to this" — a door into an
 * empty room. The sidebar uses this to leave the door out.
 */
export function isAnyBetaFeatureAvailable(): boolean {
  return Object.values(BETA_FEATURE_PERMISSION).some((permission) => auth.isAllowedTo(permission));
}
